import fetcher from 'features/shared/utils/fetcher'

async function postCurrent() {
  
  return await fetcher.get('/user/current')
}

export default postCurrent
